import React from 'react';
import { Navigate } from 'react-router-dom';

import LoginForm from 'components/templates/LoginForm';
import { useAppSelector } from 'store/hooks';
import { ROUTE_PATHS } from 'utils/constants';

const Login: React.FC = () => {
  const profile = useAppSelector((state) => state.auth.profile);

  if (profile) {
    if (!profile.customerData.onboardingFlow) {
      return <Navigate to={ROUTE_PATHS.ONBOARDING} />;
    }
    return <Navigate to={ROUTE_PATHS.AGENT} />;
  }
  return (
    <div className="p-login">
      <LoginForm />
    </div>
  );
};

export default Login;
